// @flow
import * as React from 'react';
import classNames from 'classnames';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEqual from 'react-fast-compare';
import styles from './ItemSaveIcon.module.scss';

type Props = {
    className?: string,
    iconClassName?: string,
    save: Function,
    saved: boolean | number,
};

const ItemSaveIcon = ({ className = '', iconClassName = '', save, saved = false }: Props) => {
    const icon = saved ? fasHeart : farHeart;
    const classes = classNames(styles.saveContainer, className);
    const iconClasses = classNames(styles.save, iconClassName);

    return (
        <div className={classes}>
            <FontAwesomeIcon
                className={classNames(iconClasses, styles.backgroundIcon)}
                icon={fasHeart}
                onClick={save}
            />
            <FontAwesomeIcon className={iconClasses} icon={icon} onClick={save} />
        </div>
    );
};

export default React.memo<Props>(ItemSaveIcon, isEqual);
